import { FORMATTED_LOCATION, LOCATION_AUTOCOMPLETE,
  LOCATION_DIRECTIONS, LOCATION_DIRECTIONS_V2 } from "./location.query";
import { IFormattedLocationResponse,
  ILocationDirectionsResponse, ILocationSearchResponse } from "./location.interface";

import { useLazyQuery } from "@apollo/client";

export const useLocationSearch = () => {
  const [
    autocomplete, { loading, error, data },
  ] = useLazyQuery<{ autocomplete: ILocationSearchResponse }>(LOCATION_AUTOCOMPLETE);

  const findLocation = (location: string) => {
    autocomplete({
      variables: {
        input: location,
      },
    });
  };

  return {
    findLocation,
    locations: data?.autocomplete,
    loading,
    error,
  };
};

export const useLocationDirections = () => {
  const [
    directions, { loading, error, data },
  ] = useLazyQuery<{ directions: ILocationDirectionsResponse }>(LOCATION_DIRECTIONS);

  const findDirections = (placeId: string) => {
    directions({
      variables: {
        placeId,
      },
    });
  };

  return {
    findDirections,
    directions: data?.directions,
    loading,
    error,
  };
};
export const useLocationDirectionsV2 = () => {
  const [
    directionsV2, { loading, error, data },
  ] = useLazyQuery<{ directionsV2: ILocationDirectionsResponse }>(LOCATION_DIRECTIONS_V2);

  const findDirectionsV2 = (placeId: string, page: number = 1) => {
    directionsV2({
      variables: {
        input: { placeId, page, platform: "WEBAPP" },
      },
    });
  };

  return {
    findDirectionsV2,
    directionsV2: data?.directionsV2?.directions,
    totalPages: data?.directionsV2?.totalPages,
    loading,
    error,
  };
};

export const useFormattedLocation = () => {
  const [
    getFormattedAddress, { loading, error, data },
  ] = useLazyQuery<{ getFormattedAddress: IFormattedLocationResponse }>(FORMATTED_LOCATION);

  const findFormatedLoction = (placeId: string) => {
    getFormattedAddress({
      variables: {
        placeId,
      },
    });
  };

  return {
    findFormatedLoction,
    searchData: data?.getFormattedAddress,
    loading,
    error,
  };
};
